import Dialog from './Dialog';
import styled, { css } from 'styled-components';
import Button from '../common/Button';
import ShortcutPCIcon from '../../img/img_shortcut_pc.png';
import ShortcutPCIcon2X from '../../img/img_shortcut_pc@2x.png';
import ShortcutMacIcon from '../../img/img_shortcut_mac.png';
import ShortcutMacIcon2X from '../../img/img_shortcut_mac@2x.png';
import { useAppDataSliceSelector } from '../../store/modules/appData';
import { MAC_OS_NAME } from '../../define/global';
import { useTranslation, Trans } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../store/modules/dialog';

const DialogBody = styled.div`
  width: 322px;
  height: 204px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ShortcutImage = styled.img`
  width: 180px;
  height: 68px;
`;

const Description = styled.p`
  margin-bottom: 16px;
  margin-top: 10px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #2f3133;
`;

function AddFavoriteDialog({ isShow }) {
  const appData = useAppDataSliceSelector();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <Dialog isShow={isShow} isNoHeader>
      <DialogBody>
        {appData.clientOS === MAC_OS_NAME ? (
          <ShortcutImage scr={ShortcutMacIcon} srcSet={ShortcutMacIcon2X} />
        ) : (
          <ShortcutImage scr={ShortcutPCIcon} srcSet={ShortcutPCIcon2X} />
        )}
        <Description>
          {appData.clientOS === MAC_OS_NAME ? (
            <Trans i18nKey="AddFavoriteDialog.MacDecription" />
          ) : (
            <Trans i18nKey="AddFavoriteDialog.PCDecription" />
          )}
        </Description>
        <Button
          primary
          cssExt={css`
            font-size: 13px;
            font-weight: 800;
            width: 114px;
            height: 30px;
          `}
          onClick={() => dispatch(closeDialog())}>
          {t('Common.Confirm')}
        </Button>
      </DialogBody>
    </Dialog>
  );
}

export default AddFavoriteDialog;
